var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fefffe",
    d: "M 5.5,22.5 C 101.501,22.3333 197.501,22.5 293.5,23C 296.516,24.5286 297.849,27.0286 297.5,30.5C 297.849,33.9714 296.516,36.4714 293.5,38C 197.5,38.6667 101.5,38.6667 5.5,38C 2.48396,36.4714 1.15062,33.9714 1.5,30.5C 1.2824,26.9342 2.61574,24.2675 5.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.907
    },
    fill: "#fefffe",
    d: "M 5.5,141.5 C 101.167,141.333 196.834,141.5 292.5,142C 297.738,145.274 298.904,149.774 296,155.5C 295.097,156.701 293.931,157.535 292.5,158C 197.167,158.667 101.833,158.667 6.5,158C 1.84511,155.103 0.345106,150.937 2,145.5C 3.37561,144.295 4.54227,142.962 5.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.917
    },
    fill: "#fefffe",
    d: "M 8.5,260.5 C 102.501,260.333 196.501,260.5 290.5,261C 296.939,262.705 299.106,266.872 297,273.5C 295.786,275.049 294.286,276.215 292.5,277C 197.167,277.667 101.833,277.667 6.5,277C 1.26245,273.726 0.0957862,269.226 3,263.5C 4.71891,262.131 6.55225,261.131 8.5,260.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhite);
export default __webpack_public_path__ + "static/media/Menu_white.d11991312cb725bb60c6ef79ee06c49d.svg";
export { ForwardRef as ReactComponent };